import { t as e } from "../../chunks/cn.CnaYSZq4.js";
import { getTextStyles as t } from "../textStyles.es.js";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import { Node as a } from "slate";
//#region lib/Text/components/index.tsx
var o = ({ children: n, element: a, options: o }) => {
	let l = t({}).find((e) => e.role === a?.properties?.role), u = Array.isArray(o?.countCharacters) ? o.countCharacters : [], d = c(o?.classNames) ? o.classNames : {}, f = d[l?.role || "body"] || void 0, p = a.children[0]?.text, m = o?.characterCountLabel;
	if (l && !l.role) return /* @__PURE__ */ i("div", {
		className: e("py-2 font-serif dark:tracking-wide", f),
		children: [n, /* @__PURE__ */ r(s, {
			element: a,
			type: "body",
			countTypes: u,
			label: m
		})]
	});
	switch (l?.role) {
		case "heading-1": return /* @__PURE__ */ i("div", {
			className: e("font-sans font-bold text-4xl pt-2 pb-4", f),
			children: [n, /* @__PURE__ */ r(s, {
				element: a,
				type: "heading-1",
				countTypes: u,
				label: m
			})]
		});
		case "heading-2": return /* @__PURE__ */ i("div", {
			className: e("font-sans font-bold text-xl py-2", f),
			children: [n, /* @__PURE__ */ r(s, {
				element: a,
				type: "heading-2",
				countTypes: u,
				label: m
			})]
		});
		case "preamble": return /* @__PURE__ */ i("div", {
			className: e("font-serif font-semibold py-2 dark:tracking-wide", f),
			children: [n, /* @__PURE__ */ r(s, {
				element: a,
				type: "preamble",
				countTypes: u,
				label: m
			})]
		});
		case "vignette": return /* @__PURE__ */ i("div", { children: [/* @__PURE__ */ r("span", {
			className: e(p && p.length > 0 ? "bg-slate-300 dark:text-slate-900 inline-block px-[0.4rem]" : "block dark:text-slate-400 px-0", "my-1 py-[0.2rem] font-sans font-bold text-sm", f),
			children: n
		}), /* @__PURE__ */ r(s, {
			element: a,
			type: "vignette",
			className: "normal-case",
			countTypes: u,
			label: m
		})] });
		default: return /* @__PURE__ */ i("div", {
			className: e("font-serif opacity-80 italic line-through px-1 bg-red-200 dark:text-gray-700", d.error || void 0),
			children: [n, /* @__PURE__ */ r(s, {
				element: a,
				type: "default",
				countTypes: u,
				label: m
			})]
		});
	}
}, s = ({ element: e, className: t, type: i, countTypes: o, label: s }) => {
	let c = a.string(e).length;
	return o.every((e) => typeof e == "string") && o?.includes(i) && c > 0 ? /* @__PURE__ */ r("div", {
		contentEditable: !1,
		className: ["select-none text-xs text-gray-500 w-fit font-normal font-sans", t].join(" "),
		children: `${s ?? "Number of chars"}: ${c}`
	}) : /* @__PURE__ */ r(n, {});
};
function c(e) {
	return !e || typeof e != "object" ? !1 : !!Object.values(e).filter((e) => typeof e == "string").length;
}
//#endregion
export { s as CharacterCount, o as Text };
